import { ClientInferResponseBody } from "@ts-rest/core";

import { contract } from "#app/http/api";
import { api } from "#app/http/api";

export type PartFeaturesDto = ClientInferResponseBody<typeof contract.parts.findFeatures>;

export const fetchPartFeatures = async (
  id: string | undefined,
): Promise<PartFeaturesDto | null> => {
  if (!id) {
    return null;
  }

  const response = await api.parts.findFeatures.query({ params: { id } });

  if (response.status === 200) {
    return response.body;
  }

  return null;
};
